import React from 'react';

const Handscroll = ({ className = '' }) => {
  const yBorder = (slot) => (
    <div
      className="position-absolute w-100"
      style={{
        [slot]: '35px',
        height: '50px',
        backgroundImage: 'url("/assets/img/handscroll-y.png")',
        backgroundRepeat: 'repeat-x',
        backgroundSize: 'auto 100%',
      }}
    />
  );

  const roll = (slot) => (
    <div
      className="position-absolute d-flex flex-column"
      style={{
        width: '50px',
        height: '100%',
        ...(slot === 'right' && { right: 0 }),
      }}
    >
      <img src="/assets/img/handscroll-xt.png" alt="" />
      <div
        className="flex-fill"
        style={{
          backgroundImage: 'url("/assets/img/handscroll-xc.png")',
          backgroundRepeat: 'repeat-y',
          backgroundSize: '100% auto',
        }}
      />
      <img src="/assets/img/handscroll-xb.png" alt="" />
      {/* shadow */}
      <div
        className="position-absolute w-100 h-100 d-flex flex-column"
        style={{ padding: '50px 0' }}
      >
        <div
          className="flex-fill"
          style={{ boxShadow: '30px 0 50px -11px rgba(0,0,0,.7)' }}
        />
      </div>
      {/* tassel */}
      <img
        src="/assets/img/handscroll-tassel.png"
        alt=""
        className="position-absolute top-50"
        style={{
          width: '150%',
          ...(
            slot === 'right' ? {
              right: '-104%',
              transform: 'translateY(-50%) scaleX(-1)',
            } : {
              left: '-104%',
              transform: 'translateY(-50%)',
            }
          ),
        }}
      />
    </div>
  );

  return (
    <div
      className={`
        position-absolute anim-handscroll
        h-100 start-50 translate-middle-x
        ${className}
      `}
    >
      {/* content bg */}
      <div
        className="position-absolute w-100 h-100 d-flex"
        style={{ padding: '70px 50px' }}
      >
        <div
          className="flex-fill"
          style={{
            backgroundColor: '#FBD4A4',
          }}
        />
      </div>
      {yBorder('top')}
      {yBorder('bottom')}
      {roll('left')}
      {roll('right')}
    </div>
  );
};

export default Handscroll;
